import { Component } from '@angular/core';
import { ModalSpinnerComponent } from "../ui-modal/modal.component";

@Component({
  selector: 'spinner-container',
  templateUrl: './container.component.html',
  imports: [
    ModalSpinnerComponent
  ]
})
export class SpinerContainerComponent {
}
